import { render, staticRenderFns } from "./ReviewYourAnswersFLM.vue?vue&type=template&id=9b4a254c"
import script from "./ReviewYourAnswersFLM.vue?vue&type=script&lang=ts"
export * from "./ReviewYourAnswersFLM.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports